let utils = require('../../actions/utils');
let redirect = require('../../actions/redirect');
let cookie = require('../../actions/cookie');

module.exports = {
    clickSettings: [
        utils.togglePopup('settings')
    ],

    clickLogout: [
        cookie.unsetSessionToken,
        utils.unset('user'),
        utils.set(['user', 'role'], 'unauthorized'),
        redirect.redirect('/login')
    ]
};



// WEBPACK FOOTER //
// ./signals/header/index.js